import {
  ActivityStatus,
  AttentionType,
  BlockerCategory,
  DecisionStatus,
  EvidenceKind,
  IssueStatus,
  MilestoneStatus,
  Priority,
  ProjectHealth,
  ProjectStatus,
  RiskProbability,
  RiskSeverity,
  RiskStatus,
  UserRole,
} from '@kainos/shared';

/**
 * Spanish UI copy for the English domain enums.
 *
 * Code, data and infrastructure stay in English; everything a user reads is
 * translated here, in one place, so a label change never means touching a
 * feature component.
 */

export const ACTIVITY_STATUS_LABEL: Record<ActivityStatus, string> = {
  [ActivityStatus.PENDING]: 'Pendiente',
  [ActivityStatus.IN_PROGRESS]: 'En progreso',
  [ActivityStatus.BLOCKED]: 'Bloqueada',
  [ActivityStatus.IN_REVIEW]: 'En revisión',
  [ActivityStatus.DONE]: 'Terminada',
  [ActivityStatus.CANCELLED]: 'Cancelada',
};

export const PROJECT_HEALTH_LABEL: Record<ProjectHealth, string> = {
  [ProjectHealth.NORMAL]: 'Normal',
  [ProjectHealth.ATTENTION]: 'Atención',
  [ProjectHealth.CRITICAL]: 'Crítico',
};

export const PROJECT_STATUS_LABEL: Record<ProjectStatus, string> = {
  [ProjectStatus.PLANNING]: 'Planificación',
  [ProjectStatus.IN_PROGRESS]: 'En curso',
  [ProjectStatus.AT_RISK]: 'En riesgo',
  [ProjectStatus.ON_HOLD]: 'En pausa',
  [ProjectStatus.COMPLETED]: 'Completado',
  [ProjectStatus.CANCELLED]: 'Cancelado',
};

export const PRIORITY_LABEL: Record<Priority, string> = {
  [Priority.LOW]: 'Baja',
  [Priority.MEDIUM]: 'Media',
  [Priority.HIGH]: 'Alta',
  [Priority.CRITICAL]: 'Crítica',
};

export const RISK_SEVERITY_LABEL: Record<RiskSeverity, string> = {
  [RiskSeverity.LOW]: 'Baja',
  [RiskSeverity.MEDIUM]: 'Media',
  [RiskSeverity.HIGH]: 'Alta',
  [RiskSeverity.CRITICAL]: 'Crítica',
};

export const RISK_PROBABILITY_LABEL: Record<RiskProbability, string> = {
  [RiskProbability.LOW]: 'Baja',
  [RiskProbability.MEDIUM]: 'Media',
  [RiskProbability.HIGH]: 'Alta',
};

export const RISK_STATUS_LABEL: Record<RiskStatus, string> = {
  [RiskStatus.PROPOSED]: 'Propuesto',
  [RiskStatus.OPEN]: 'Abierto',
  [RiskStatus.MITIGATED]: 'Mitigado',
  [RiskStatus.ACCEPTED]: 'Aceptado',
  [RiskStatus.CLOSED]: 'Cerrado',
  [RiskStatus.DISMISSED]: 'Descartado',
};

export const ISSUE_STATUS_LABEL: Record<IssueStatus, string> = {
  [IssueStatus.OPEN]: 'Abierto',
  [IssueStatus.IN_PROGRESS]: 'En gestión',
  [IssueStatus.RESOLVED]: 'Resuelto',
  [IssueStatus.CLOSED]: 'Cerrado',
};

export const DECISION_STATUS_LABEL: Record<DecisionStatus, string> = {
  [DecisionStatus.PENDING]: 'Pendiente',
  [DecisionStatus.APPROVED]: 'Aprobada',
  [DecisionStatus.REJECTED]: 'Rechazada',
  [DecisionStatus.DEFERRED]: 'Aplazada',
};

export const MILESTONE_STATUS_LABEL: Record<MilestoneStatus, string> = {
  [MilestoneStatus.PLANNED]: 'Planificado',
  [MilestoneStatus.AT_RISK]: 'En riesgo',
  [MilestoneStatus.DELAYED]: 'Atrasado',
  [MilestoneStatus.ACHIEVED]: 'Cumplido',
};

export const ATTENTION_TYPE_LABEL: Record<AttentionType, string> = {
  [AttentionType.BLOCKER]: 'Bloqueo',
  [AttentionType.DELAY]: 'Atraso',
  [AttentionType.RISK]: 'Riesgo',
  [AttentionType.DECISION]: 'Decisión',
  [AttentionType.STALE]: 'Sin actualización',
};

export const EVIDENCE_KIND_LABEL: Record<EvidenceKind, string> = {
  [EvidenceKind.PHOTO]: 'Fotografía',
  [EvidenceKind.DOCUMENT]: 'Documento',
  [EvidenceKind.VIDEO]: 'Video',
  [EvidenceKind.OTHER]: 'Archivo',
};

export const BLOCKER_CATEGORY_LABEL: Record<BlockerCategory, string> = {
  [BlockerCategory.MATERIAL]: 'Materiales',
  [BlockerCategory.EQUIPMENT]: 'Equipos',
  [BlockerCategory.PERSONNEL]: 'Personal',
  [BlockerCategory.PERMIT]: 'Permisos',
  [BlockerCategory.DESIGN]: 'Diseño',
  [BlockerCategory.WEATHER]: 'Clima',
  [BlockerCategory.SUPPLIER]: 'Proveedor',
  [BlockerCategory.DEPENDENCY]: 'Dependencia',
  [BlockerCategory.OTHER]: 'Otra causa',
};

export const USER_ROLE_LABEL: Record<UserRole, string> = {
  [UserRole.OWNER]: 'Propietario',
  [UserRole.ADMIN]: 'Administrador',
  [UserRole.PROJECT_MANAGER]: 'Project Manager',
  [UserRole.MEMBER]: 'Miembro',
  [UserRole.VIEWER]: 'Observador',
};
